import { v4 as uuidv4 } from 'uuid';

import { IKnmAccessPrivilege } from '../../../APIPackage/KnmModule/interfaces/IKnmAccessPrivilege';
import { IKnmFormAccessPrivilege } from '../interfaces/IKnmFormAccessPrivilege';
import { getDictionarySelectOptionWithState } from '../../../CorePackage/DictionariesModule/common/getDictionarySelectOptionWithState';
import { DictionaryUUIDsEnum } from '../../../CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IKnoOrganizationBrief } from '../../../APIPackage/CatalogsModule/interfaces/IKnoOrganizationBrief';
import { createKnmAccessLevelSelectOption } from '../../../CorePackage/CatalogsModule/common/createKnmAccessLevelSelectOption';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';

export function convertKnmDataAccessPrivilegesToFormValues(
  data: IKnmAccessPrivilege[] | null | undefined,
  state: IRootState,
): IKnmFormAccessPrivilege[] {
  return (
    data?.map(item => {
      const selectOption = getDictionarySelectOptionWithState<typeof DictionaryUUIDsEnum.KNO_ORGANIZATIONS>(
        state,
        DictionaryUUIDsEnum.KNO_ORGANIZATIONS,
        item.dictVersionId,
      );
      const organisation: IKnoOrganizationBrief | undefined = selectOption
        ? {
            ...selectOption,
            ogrn: selectOption.ogrn || undefined,
            guid: selectOption.guid || undefined,
            dictVersionId: selectOption.value.dictVersionId,
          }
        : undefined;
      const formAccessPrivilege: IKnmFormAccessPrivilege = {
        organisation,
        accessLevel: item.accessPrivilegeLevel
          ? createKnmAccessLevelSelectOption(item.accessPrivilegeLevel)
          : undefined,
        guid: item.guid || uuidv4(),
      };

      return formAccessPrivilege;
    }) || []
  );
}
